import { render, staticRenderFns } from "./ManageSigners.vue?vue&type=template&id=0ceac963&scoped=true"
import script from "./ManageSigners.vue?vue&type=script&lang=js"
export * from "./ManageSigners.vue?vue&type=script&lang=js"
import style0 from "./ManageSigners.vue?vue&type=style&index=0&id=0ceac963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceac963",
  null
  
)

export default component.exports